import { createContext, useContext } from 'react';

/**
 * Lives outside App.component so that consumers (notably DashboardLayout, which
 * App renders transitively) can read the context without importing back into
 * App.component and forming an import cycle.
 */
export const ThemeContext = createContext({
    toggleSidebarMinified: () => {},
});

export const useThemeContext = () => useContext(ThemeContext);
